(function () {
  'use strict';

  function serverError() {
    var link = function ($scope, element, attr) {
      $scope.$on('server-errors', function (event, serverErrors) {
        // shows errors
        if (angular.isObject(serverErrors)) {
          console.log('server-errors', serverErrors)
          // A 422 from any endpoint is broadcast to every form on the page; the
          // first-comment wait (KB-8789) rejects comment posts with 422, so a form
          // not on scope or an error without a field must not throw here.
          var form = $scope[attr.name];
          if (!form || !serverErrors.data) {
            return;
          }
          angular.forEach(serverErrors.data.errors, function (error) {
            if (!error || typeof error.field !== 'string') {
              return;
            }
            var field = form[error.field.toCamelCase()];

            if (field) {
              field.$error.message = error.message;
              field.$setValidity('server', false);
            }
          });
        }
      });
    };

    return {
      restrict: 'A',
      link: link
    };
  }

  app.directive('serverError', serverError);
})();
